import { PUBLIC_WEB_URL } from "../../config/env.js";

/** A venue advance link's absolute URL, built on the PUBLIC-WEB origin (the host that serves /venue/*) — never
 *  the app's own origin on native, where that is https://localhost. Falls back to the origin for a same-origin web
 *  build. Shared by the desktop link card and the mobile LINK pill (ART-251). */
export function absolutePublicUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  const base = PUBLIC_WEB_URL || (typeof window !== "undefined" ? window.location.origin : "");
  return `${base}${path}`;
}
